import axios from "axios";
import { authHeader, API_URL } from "./auth.service";
const API = `${API_URL}/guia`;
export const getGuias = async (params) => {
  try {
    return new Promise((resolve, reject) => {
      axios.get(`${API}/getGuias`, {
        params: params,
        headers: authHeader(),
      }).then(response => {
        resolve(response)
      }).catch(error => {
        resolve(error.response)
      })
    })
  } catch (error) {
    return null;
  }
};
export const getGuiaDetalle = async (params) => {
  try {
    return new Promise((resolve, reject) => {
      axios.get(`${API}/getGuiaDetalle`, {
        params: params,
        headers: authHeader(),
      }).then(response => {
        resolve(response)
      }).catch(error => {
        resolve(error.response)
      })
    })
  } catch (error) {
    return null;
  }
};
export const getItem = async (params) => {
  try {
    return new Promise((resolve, reject) => {
      axios.get(`${API}/getItem`, {
        params: params,
        headers: authHeader(),
      }).then(response => {
        resolve(response)
      }).catch(error => {
        resolve(error.response)
      })
    })
  } catch (error) {
    return null;
  }
};